export const UserTitleType = {
  MISS: { name: 'MISS', displayName: 'Miss', comment: '미혼여성' },
  MR: { name: 'MR', displayName: 'Mr', comment: '기혼남성' },
  MRS: { name: 'MRS', displayName: 'Mrs', comment: '기혼여성' },
  MS: { name: 'MS', displayName: 'Ms', comment: '미혼남성' }
} as const;

export type UserTitleTypeKey = keyof typeof UserTitleType;
export type UserTitleDisplayName = (typeof UserTitleType)[UserTitleTypeKey]['displayName'];

export const displayNameToTypeMap: Record<UserTitleDisplayName, UserTitleTypeKey> = {
  Miss: 'MISS',
  Mr: 'MR',
  Mrs: 'MRS',
  Ms: 'MS'
} as const;

export const UserTitleTypeUtils = {
  fromDisplayName(displayName: string): UserTitleTypeKey {
    return displayNameToTypeMap[displayName as UserTitleDisplayName] ?? 'MISS';
  },

  toDisplayName(type: UserTitleTypeKey): UserTitleDisplayName {
    return UserTitleType[type].displayName;
  },

  getComment(type: UserTitleTypeKey): string {
    return UserTitleType[type].comment;
  },

  getAllDisplayNames(): UserTitleDisplayName[] {
    return Object.values(UserTitleType).map(({ displayName }) => displayName);
  },

  isValidType(type: string): type is UserTitleTypeKey {
    return type in UserTitleType;
  },

  isValidDisplayName(displayName: string): displayName is UserTitleDisplayName {
    return displayName in displayNameToTypeMap;
  }
} as const;

export type UserTitleOption = {
  label: UserTitleDisplayName;
  value: UserTitleTypeKey;
};

export const userTitleOptions = Object.entries(UserTitleType).map(([key]) => ({
  label: UserTitleTypeUtils.toDisplayName(key as UserTitleTypeKey),
  value: UserTitleTypeUtils.toDisplayName(key as UserTitleTypeKey)
})) as UserTitleOption[];
